<template>
  <span class="hidden" />
</template>

<script>
import * as menuConstants from '../constants/menu'

export default {

	name: 'Authenticate',
	computed: {

		authenticated: function () {
			return this.$store.getters.isAuthenticated
		}
	},

	watch: {

		authenticated: function () {
			// they have a valid token
			if (this.authenticated) {
				// get their customer record
				this.$store.dispatch('getAccount')
			}
		}
	},

	mounted () {
		// get the current podium state
		this.$store.dispatch('getCurrentLiveInventoryId')

		// call our authenticate dispatch to try to authenticate with an existing cookie
		let payload = {}
		payload = {}
		payload.context = 'authenticate'
		payload.page = this.$attrs['page']
		this.$store.dispatch('authenticate', payload)

		// if there is an overlay (which we use on lot page load), make sure it is translucent
		let overlayFader = document.getElementById('overlayFader')
		if (overlayFader !== null) {
			overlayFader.classList.add('transparent')
		}

		if (window.location.hash) {
			let hash = window.location.hash
			const hashes = menuConstants.MENU_ITEMS.map(x => x.hash)
			if (hashes.includes(hash)) {
				// Find the MENU ITEM that matches the hash
				let menuItem = menuConstants.MENU_ITEMS.find(x => x.hash === hash)
				this.insertAccountMenu(menuItem.name, hash)
			}
		}
	},
	methods: {
		insertAccountMenu (payload, hash) {
			let modalPayload = {
				'component': 'AccountPage',
				'props': []
			}

			// show the modal
			// this.$store.dispatch('deleteAccountHistory')
			this.$store.dispatch('showModal', modalPayload)
			this.$store.dispatch('deleteAccountHistory')
			window.location.hash = hash
			this.$store.dispatch('insertAccountHistory', payload)
		}
	}
}

</script>
<style></style>
